import React, { FC, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import {
  DetailedProject as DetailedProjectModel,
  isAnnounced,
  ProjectStatus,
  Reservation,
  UserPlan,
} from 'api-client';
import axios from 'axios';

import { createReservationManager } from '../../../di';
import { useErrorCallback, useProfileData } from '../../../hooks';
import { RouteDictionary } from '../../../utils';
import { ChevronIcon, CustomLink, Loader } from '../../common';
import DetailedProjectContextProvider from '../../pages/detailed-project/DetailedProjectContext';
import { DetailedProjectContextType } from '../../pages/detailed-project/DetailedProjectContext/DetailedProjectContext';
import DetailedProjectMobileNavigation from '../../pages/detailed-project/DetailedProjectMobileNavigation';
import ProjectInvest from '../../pages/detailed-project/ProjectInvest';
import ProjectMain from '../../pages/detailed-project/ProjectMain';
import ProjectReserve from '../../pages/detailed-project/ProjectReserve';

import './DetailedProject.scoped.scss';

type Props = {
  project: DetailedProjectModel;
};

const DetailedProject: FC<Props> = ({ project }) => {
  const [reservation, setReservation] = useState<Reservation | null>(null);
  const [reservationLoading, setReservationLoading] = useState(true);
  const value: DetailedProjectContextType = {
    project: project,
    reservation,
    reservationLoading,
  };
  const profileData = useProfileData();

  const handleError = useErrorCallback();

  useEffect(() => {
    (async () => {
      try {
        const reservationManager = await createReservationManager();
        const result = await reservationManager.getByProject(project.uuid);
        setReservation(result);
      } catch (error) {
        if (!(axios.isAxiosError(error) && error.response?.status === 404)) {
          if (error instanceof Error) await handleError(error);
        }
      } finally {
        setReservationLoading(false);
      }
    })();
  }, [project.uuid]);

  return (
    <DetailedProjectContextProvider props={value}>
      <CustomLink className="detailed-project-back" to={RouteDictionary.PRIMARY_MARKET}>
        <ChevronIcon direction="left" title="К списку проектов" color={'var(--black-color)'} />
      </CustomLink>
      {reservationLoading ? (
        <Loader />
      ) : (
        <div className="detailed-project">
          <ProjectMain />
          {isAnnounced(project.status) &&
            project.reservationLimit &&
            profileData.userPlan === UserPlan.CONOMICA_PLUS && <ProjectReserve />}
          {project.status === ProjectStatus.FUND_RAISING && <ProjectInvest />}
          <div className="detailed-project-outlet">
            <DetailedProjectMobileNavigation />
            <Outlet />
          </div>
        </div>
      )}
    </DetailedProjectContextProvider>
  );
};

export default DetailedProject;
